import React from "react";

import "./styles.scss";
import { Modal, Button } from "react-bootstrap";

const ModalConfirmarDelete = ({ show, handleClose, handleDelete }) => {
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Confirmação</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Tem certeza que deseja excluir?</p>
      </Modal.Body>
      <Modal.Footer>
        <Button
          className="btn-cancelar"
          variant="secondary"
          onClick={handleClose}
        >
          Cancelar
        </Button>
        <Button variant="danger" onClick={handleDelete}>
          Excluir
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalConfirmarDelete;
